import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";

const CommunicationWithHCDivision = () => {
  const { i18n, t } = useTranslation();

  return (
    <InnerPageLayout>
      <Container>
        <Card
          id={i18n.language === "en" ? "custom-card-en" : "custom-card-ar"}
          className="custom-card right mb-4"
        >
          <Card.Header className="custom-card-header">
            {t('hr_communicate_with_hc')}
          </Card.Header>
          <Card.Body className="d-flex p-0">
            <Col className="text-right">
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  color: "#333",
                  textAlign: "justify",
                  padding: "10px",
                }}
              >
                {t('hr_contact_details')}
              </p>

              {/* Recruitment */}
              <Row className="justify-content-md-center mb-3">
                <Col xs lg="2">
                  {t('recruitment')}
                </Col>
                <Col md="auto">:</Col>
                <Col xs lg="2">
                  <a
                    href="mailto:Recruitment@tatweer.sa"
                    style={{ color: "#007bff", textDecoration: "none" }}
                  >
                    Recruitment@tatweer.sa
                  </a>
                </Col>
              </Row>

              {/* Training */}
              <Row className="justify-content-md-center mb-3">
                <Col xs lg="2">
                {t('training')}
                </Col>
                <Col md="auto">:</Col>
                <Col xs lg="2">
                  <a
                    href="mailto:Training@tatweer.sa"
                    style={{ color: "#007bff", textDecoration: "none" }}
                  >
                    Training@tatweer.sa
                  </a>
                </Col>
              </Row>

              {/* Payroll */}
              <Row className="justify-content-md-center mb-3">
                <Col xs lg="2">
                {t('salaries')}

                </Col>
                <Col md="auto">:</Col>
                <Col xs lg="2">
                  <a
                    href="mailto:Payroll@tatweer.sa"
                    style={{ color: "#007bff", textDecoration: "none" }}
                  >
                    Payroll@tatweer.sa
                  </a>
                </Col>
              </Row>

              {/* Employee Relations */}
              <Row className="justify-content-md-center mb-3">
                <Col xs lg="2">
                  {t('employee_relations')}

                </Col>
                <Col md="auto">:</Col>
                <Col xs lg="2">
                  <a
                    href="mailto:Hc.operation@tatweer.sa"
                    style={{ color: "#007bff", textDecoration: "none" }}
                  >
                    Hc.operation@tatweer.sa
                  </a>
                </Col>
              </Row>

              {/* Attendance */}
              <Row className="justify-content-md-center mb-3">
                <Col xs lg="2">
                    {t('attendance')}
                </Col>
                <Col md="auto">:</Col>
                <Col xs lg="2">
                  <a
                    href="mailto:Attendance@tatweer.sa"
                    style={{ color: "#007bff", textDecoration: "none" }}
                  >
                    Attendance@tatweer.sa
                  </a>
                </Col>
              </Row>

              {/* Organizational Development */}
              <Row className="justify-content-md-center mb-3">
                <Col xs lg="2">
                {t('organizational_development')}

                </Col>
                <Col md="auto">:</Col>
                <Col xs lg="2">
                  <a
                    href="mailto:OD@tatweer.sa"
                    style={{ color: "#007bff", textDecoration: "none" }}
                  >
                    OD@tatweer.sa
                  </a>
                </Col>
              </Row>

              {/* Internal Communication */}
              <Row className="justify-content-md-center mb-3">
                <Col xs lg="2">
                {t('internal_communication_and_suggestions')}
                </Col>
                <Col md="auto">:</Col>
                <Col xs lg="2">
                  <a
                    href="mailto:Hric@tatweer.sa"
                    style={{ color: "#007bff", textDecoration: "none" }}
                  >
                    Hric@tatweer.sa
                  </a>
                </Col>
              </Row>
            </Col>
          </Card.Body>
        </Card>
      </Container>
    </InnerPageLayout>
  );
};

export default CommunicationWithHCDivision;
